import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteUserDocument = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const deleteUserDocument = (id: string, onDeleted: (id: string) => void) => {
        const { exec } = userApi.deleteUserDocument({
            params: { id },
            onSuccess: () => {
                onDeleted(id);
                toastHandler.push(`success`, t('userDocuments.deleteTitle'), t('userDocuments.deleteSuccess'));
            },
            onError: () => toastHandler.push(`error`, t('userDocuments.deleteTitle'), t('userDocuments.deleteError')),
        });
        exec();
    };

    return { deleteUserDocument };
};

export default useHttpDeleteUserDocument;
